import { Box, Tab, Tabs } from "@mui/material";
import { ScopeDetailsTab } from "../../types";

interface ScopeDetailsNavigationProps {
    tab: ScopeDetailsTab;
    setTab: (tab: ScopeDetailsTab) => void;
    fieldsEnabled?: boolean;
    isV2?: boolean;
}

export const ScopeDetailsNavigation = ({
    tab,
    setTab,
    fieldsEnabled = true,
}: ScopeDetailsNavigationProps) => {
    const handleChange = (
        _: React.SyntheticEvent,
        newValue: ScopeDetailsTab
    ) => {
        setTab(newValue);
    };

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs variant="fullWidth" value={tab} onChange={handleChange}>
                {fieldsEnabled && (
                    <Tab
                        label="Fields"
                        sx={{ textTransform: "none" }}
                        value={ScopeDetailsTab.FIELDS}
                    />
                )}

                <Tab
                    label="Clauses"
                    sx={{ textTransform: "none" }}
                    value={ScopeDetailsTab.CLAUSES}
                />
            </Tabs>
        </Box>
    );
};
